export default "__VITE_PUBLIC_ASSET__4e03a225__"